import { render, staticRenderFns } from "./SelectedNum.vue?vue&type=template&id=3d081f8e&scoped=true&"
import script from "./SelectedNum.vue?vue&type=script&lang=js&"
export * from "./SelectedNum.vue?vue&type=script&lang=js&"
import style0 from "./SelectedNum.vue?vue&type=style&index=0&id=3d081f8e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d081f8e",
  null
  
)

export default component.exports